import { Component, Input, OnInit, OnChanges, SimpleChanges} from "@angular/core";

import { TrocaIPOCDTO, DiasAtrasoDTO, LabelTipoAcao } from "src/app/model/consulta-ipoc.model";
import { EntityOrderedRequestParameters, EntityPagedRequestParameters } from "@bndes/bndes-ux4/bndes-angular-utils";
import { PermissaoService } from "src/app/shared/permissao.service";
import { ROLE_AGENTE_CONSULTA, ROLE_GESTOR_CONSULTA } from "src/app/constantes/permissao.constants";
import Utils from "src/app/shared/fgi-utils";
import { Observable } from "rxjs/internal/Observable";
import { BnConfirmDirective } from "@bndes/bndes-ux4/bn-confirm";
import { BnModalMessageService } from "@bndes/bndes-ux4/bn-modal-message";
import { MensagemService } from "src/app/features/mensagem.service";
import { ConsultaIpocService } from "../../consulta-ipoc.service";


@Component({
    selector: 'app-aba-troca-ipoc',
    templateUrl: './aba-troca-ipoc.component.html',
    styleUrls: ['./aba-troca-ipoc.component.scss'],
    standalone: false
})
export class AbaTrocaIpocComponent implements OnInit, OnChanges {

  @Input() public trocasIPOC: TrocaIPOCDTO[];
  @Input() public diasAtraso: DiasAtrasoDTO[] = [];
  @Input() public atributosPaginacaoAbaTrocaIpoc: EntityPagedRequestParameters;
  @Input() public opcoesPaginacaoTrocaIpoc: number[];
  @Input() public atributosPaginacaoAbaDiasAtraso: EntityPagedRequestParameters;
  @Input() public opcoesPaginacaoDiasAtraso: number[];
  @Input() public permissaoEdicao:  boolean = false;
  @Input() public opcaoMostrarTodosIpocs: boolean = false;

  
  public labelTipoAcao = LabelTipoAcao;
  public atributosOrdenacao: EntityOrderedRequestParameters;
  public listaAtraso: DiasAtrasoDTO[];
  public listaIpoc: TrocaIPOCDTO[];
  public countAtraso: number;
  public countTrocasIpoc: number;
  private isAgente: boolean;

  constructor(private permissaoService: PermissaoService,
    private modalService: BnModalMessageService,
    private mensagemService: MensagemService,
    private consultaIpocService : ConsultaIpocService,
    ){
  }

  ngOnInit(): void {
    this.permissaoService.getPermissoesUsuarioAutenticado().subscribe((resp: any) => {
      this.isAgente = resp && resp[ROLE_AGENTE_CONSULTA];
    });
    this.atributosOrdenacao = {
      atributo: '',
      sentido: 'asc'
    };
  }

  ngOnChanges(changes: SimpleChanges): void{

    this.navegarIPOC(this.atributosPaginacaoAbaTrocaIpoc);
    this.navegarDiasAtraso(this.atributosPaginacaoAbaDiasAtraso);
  }

  retornaLabelTipoAcao(tipoAcao):string{ 
    return this.labelTipoAcao.filter(e=>e.codigo==tipoAcao)[0].nome;
  }

  mudancaPaginaIpoc(novaPaginaIpoc: EntityPagedRequestParameters) {

    this.atributosPaginacaoAbaTrocaIpoc = novaPaginaIpoc;
    this.navegarIPOC(this.atributosPaginacaoAbaTrocaIpoc);
  }
  mudancaPaginaDiasAtraso(novaPaginaDiasAtraso: EntityPagedRequestParameters) {

    this.atributosPaginacaoAbaDiasAtraso = novaPaginaDiasAtraso;
    this.navegarDiasAtraso(this.atributosPaginacaoAbaDiasAtraso);
  }

  public navegarDiasAtraso(pesq: EntityPagedRequestParameters) {

    let posInicial: number, posFinal: number;

    posInicial = (pesq.page-1) * pesq.pageSize;
    posFinal = posInicial + pesq.pageSize;

    if (posFinal > this.diasAtraso.length) {
      posFinal = this.diasAtraso.length;
    }

    this.listaAtraso = this.diasAtraso.slice(posInicial,posFinal);
    this.countAtraso = this.diasAtraso.length;
  }

  public navegarIPOC(pesq: EntityPagedRequestParameters) {

    let posInicial: number, posFinal: number;

    posInicial = (pesq.page-1) * pesq.pageSize;
    posFinal = posInicial + pesq.pageSize;
    if (posFinal > this.trocasIPOC.length) {
      posFinal = this.trocasIPOC.length;
    }
    //Se trocar a opcaoMostrarTodosIpocs, verificar se a pagina do outro existe
    if(posInicial > this.trocasIPOC.length){ 
      posInicial=0;
      pesq.page = 1;
    }
    this.listaIpoc = this.trocasIPOC.slice(posInicial,posFinal);
    this.countTrocasIpoc = this.trocasIPOC.length;
  }

  mudancaOrdenacao(novaOrdenacao: EntityOrderedRequestParameters) {
    this.atributosOrdenacao = novaOrdenacao;
    this.pesquisarOrdenacaoTrocasIpoc(this.atributosOrdenacao);
    this.pesquisarOrdenacaoDiasAtraso(this.atributosOrdenacao);
  }

  pesquisarOrdenacaoTrocasIpoc(ord: EntityOrderedRequestParameters) {
    this.listaIpoc = this.listaIpoc.sort((a, b) => {
      if (ord.sentido == "asc") {
        return Utils.compara(a, b, ord.atributo);
      }
      else {
        return -1 * Utils.compara(a, b, ord.atributo);
      }
    });
  }

  pesquisarOrdenacaoDiasAtraso(ord: EntityOrderedRequestParameters) {
    this.listaAtraso = this.listaAtraso.sort((a, b) => {
      if (ord.sentido == "asc") {
        return Utils.compara(a, b, ord.atributo);
      }
      else {
        return -1 * Utils.compara(a, b, ord.atributo);
      }
    });
  }

  desativarIPOC(trocaIpocDesativada: TrocaIPOCDTO): void{
    this.abreModalConfirmacao("Deseja desativar o Ipoc ?").then((resp) =>{
      if(resp === true){
        this.consultaIpocService.desativarIpoc(trocaIpocDesativada.idTrocaIpocScr,trocaIpocDesativada.idOperacaoGarantida).subscribe((ipocAtualizado : TrocaIPOCDTO[]) => {
         
          if(!this.opcaoMostrarTodosIpocs) {
            this.listaIpoc = this.listaIpoc.filter(troca => troca.idTrocaIpocScr !== trocaIpocDesativada.idTrocaIpocScr);
            this.trocasIPOC = this.trocasIPOC.filter(troca => troca.idTrocaIpocScr !== trocaIpocDesativada.idTrocaIpocScr);
          }
        
          if(this.opcaoMostrarTodosIpocs){
            ipocAtualizado.forEach(t => {
              if(t.idTrocaIpocScr == trocaIpocDesativada.idTrocaIpocScr) trocaIpocDesativada.dataDesativacao = t.dataDesativacao;
            })
          }
          
          this.mensagemService.adicionarMensagemSucesso('IPOC , número: '+ trocaIpocDesativada.numeroIpocNovo +', desativado com sucesso.');
        });
        
      }
    })
  }

  async abreModalConfirmacao(mensagem: string): Promise<boolean> {
    const titulo = 'Confirmação';

    try {
        const resultadoConfimacao = await this.modalService.abrirConfirm(titulo, mensagem).result;
        return resultadoConfimacao.value === 'ok';
    } catch (e) {
        return false;
    }
  }

}



